import { type ReactElement, type ReactNode } from 'react'
import { Divider, Grid, Stack } from '@mantine/core'
import { useTranslation } from '@front/model'
import { TButton } from '../buttons'
import { CHANGED_PERMISSION_GROUP_KEY } from './util'

type Props = {
  categories: string[]
  currentGroup: string | undefined
  onSelect: (category: string) => void
  children: ReactNode
}

export const PermissionCategorySidebar = ({ categories, currentGroup, onSelect, children }: Props): ReactElement => {
  const { t } = useTranslation()

  return (
    <Grid>
      <Grid.Col span='content'>
        <Stack>
          <TButton
            color={currentGroup === CHANGED_PERMISSION_GROUP_KEY ? 'brand' : 'neutral'}
            justify='left'
            variant='ghost'
            onClick={() => onSelect(CHANGED_PERMISSION_GROUP_KEY)}
          >
            {t('Changes')}
          </TButton>
          <Divider />
          {categories.map((category) => (
            <TButton
              color={currentGroup === category ? 'brand' : 'neutral'}
              justify='left'
              key={category}
              variant='ghost'
              onClick={() => onSelect(category)}
            >
              {category}
            </TButton>
          ))}
        </Stack>
      </Grid.Col>
      <Divider mx='xl' orientation='vertical' />
      <Grid.Col span='auto'>{children}</Grid.Col>
    </Grid>
  )
}
